import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [link, setLink] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            const { data } = await api.post("/auth/forgot-password", { email: email.toLowerCase().trim() });
            if (data.reset_link) setLink(data.reset_link);
            else setLink("If the email exists in our system, a reset link has been issued.");
            toast.success("Reset link generated");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Request failed");
        } finally { setBusy(false); }
    };

    return (
        <div className="min-h-screen bg-white flex items-center justify-center p-8">
            <form onSubmit={submit} className="w-full max-w-md">
                <div className="tag-pill mb-6">Reset</div>
                <h2 className="text-3xl font-bold tracking-tight mb-2">Forgot your password?</h2>
                <p className="text-sm text-zinc-500 mb-8">
                    Enter your email and we'll generate a reset link.
                </p>
                <div className="space-y-1.5">
                    <Label className="text-[11px] uppercase tracking-wider text-zinc-500">Email</Label>
                    <Input
                        type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                        className="h-11 rounded-none" data-testid="forgot-email"
                    />
                </div>
                <Button type="submit" disabled={busy} className="w-full mt-6 rounded-none h-12 bg-[#002FA7] hover:bg-[#00227B]" data-testid="forgot-submit">
                    {busy ? "Working…" : "Send reset link"}
                </Button>
                {link && (
                    <div className="mt-6 border-2 border-[#09090b] p-4 text-xs font-mono break-all" data-testid="forgot-reset-link">
                        <div className="text-[10px] uppercase tracking-wider text-zinc-500 mb-2">Reset link (dev mode — share with user)</div>
                        {link.startsWith("http") ? <a href={link} className="text-[#002FA7] underline">{link}</a> : link}
                    </div>
                )}
                <p className="mt-6 text-xs text-zinc-500 font-mono">
                    <Link to="/login" className="text-[#002FA7] hover:underline">← Back to sign in</Link>
                </p>
            </form>
        </div>
    );
}
